// import React, { useState, useCallback } from "react";
import styles from "./daySelectionWeekDays.module.scss";
import React, { useState, useCallback } from "react";
const DaySelectionWeekDays = ({
  onSaveDates,
  defaultSelectedDays,
  disabled,
}) => {
  const [selectedDays, setSelectedDays] = useState(defaultSelectedDays || []);
  const daysOfWeek = ["sun", "mon", "tue", "wed", "thr", "fri", "sat"];
 
  // Create day selection object
  const getDaySelectionObject = useCallback(() => {
    const daySelection = {};
    daysOfWeek.forEach((day) => {
      daySelection[day] = selectedDays.includes(day) ? 1 : 0;
    });
    return daySelection;
  }, [selectedDays, daysOfWeek]);
 
  // Handle day changes and notify parent
  const handleDayChange = (day) => {
    setSelectedDays((prevSelectedDays) => {
      const newSelectedDays = prevSelectedDays.includes(day)
        ? prevSelectedDays.filter((d) => d !== day)
        : [...prevSelectedDays, day];
      onSaveDates(getDaySelectionObject(newSelectedDays));
      return newSelectedDays;
    });
  };
 
  // Helper to update days and notify parent
  const updateSelectedDays = (newDays) => {
    setSelectedDays(newDays);
    const daySelection = {};
    daysOfWeek.forEach((day) => {
      daySelection[day] = newDays.includes(day) ? true : false;
    });
    onSaveDates(daySelection);
  };
 
  // Select weekdays (Monday to Friday)
  const selectWeekdays = () => {
    const weekdays = daysOfWeek.slice(1, 6);
    updateSelectedDays(weekdays);
  };
 
  // Select weekends (Saturday and Sunday)
  const selectWeekends = () => {
    updateSelectedDays(["sun", "sat"]);
  };
 
  // Select all days (custom)
  const selectCustom = () => {
    updateSelectedDays(daysOfWeek);
  };
 
  // Check selection states
  const isWeekdaySelected = daysOfWeek.slice(1, 6).every(day => selectedDays.includes(day))
    && selectedDays.length === 5;
 
  const isWeekendSelected = selectedDays.includes("sun")
    && selectedDays.includes("sat")
    && selectedDays.length === 2;
 
  const isCustomSelected = () => {
    const weekdays = daysOfWeek.slice(1, 6);
    const weekends = ["sun", "sat"];
    return (
      selectedDays.length > 0 &&
      (selectedDays.length === 7 ||
       (selectedDays.some(day => weekdays.includes(day)) &&
        selectedDays.some(day => weekends.includes(day))) ||
       selectedDays.length === 1 ||
       (!isWeekdaySelected && !isWeekendSelected))
    );
  };
 
  return (
    <div>
      <div style={{ display: "flex", marginBottom: "10px" }}>
        <button
          onClick={selectWeekdays}
          className={`${styles.selectDayButtons} ${isWeekdaySelected ? styles.selected : ""}`}
          disabled={disabled}
        >
          Weekdays
        </button>
        <button
          onClick={selectWeekends}
          className={`${styles.selectDayButtons} ${isWeekendSelected ? styles.selected : ""}`}
          disabled={disabled}
        >
          Weekends
        </button>
        <button
          onClick={selectCustom}
          className={`${styles.selectDayButtons} ${isCustomSelected() ? styles.selected : ""}`}
          disabled={disabled}
        >
          Custom
        </button>
      </div>
 
      <div className="flex flex_gap_10">
        {daysOfWeek.map((day, index) => (
          <label key={index} className={styles.dayName}>
            <input
              type="checkbox"
              checked={selectedDays.includes(day)}
              onChange={() => handleDayChange(day)}
              disabled={disabled}
            />
            {day}
          </label>
        ))}
      </div>
    </div>
  );
};
 
export default React.memo(DaySelectionWeekDays);
 